<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu
            offset-y
            v-if="
              user.role.roleName != 'WAREHOUSE_MANAGER' &&
              user.role.roleName != 'WAREHOUSE_STAFF'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on">
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllProductionOrder()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="shopList"
                label="Choose Shop"
                v-model="queryParams.shopId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                :readonly="checkShopUser() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="warehouseList"
                label="Choose Warehouse"
                v-model="queryParams.warehouseId"
                item-text="name"
                item-value="id"
                :hide-no-data="true"
                :readonly="checkWarehouseUser() ? true : false"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="poNo"
                label="PO No"
                type="text"
                v-model="queryParams.poNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="productionPlanNo"
                label="Production Plan No"
                type="text"
                v-model="queryParams.productionPlanNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="productCode"
                label="Product Code"
                type="text"
                v-model="queryParams.productCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="productName"
                label="Product Name"
                type="text"
                v-model="queryParams.productName"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="productionOrderList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            must-sort
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click="onEdit(props.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  color="blue lighten-2"
                  @click.stop="reprint(props.item)"
                >
                  <v-icon>print</v-icon>
                </v-btn>
              </td>
              <td>
                {{ props.item.status }}
              </td>
              <td>{{ props.item.issueDateInMilliSeconds | formatMsDate }}</td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.poNo }}</td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.fromDepartmentName }}</td>
              <td>{{ props.item.toDepartmentName }}</td>
              <td>{{ props.item.productionPlanNo }}</td>
              <td>{{ props.item.productName }}</td>
              <td>{{ props.item.factorUnitName }}</td>
              <td>{{ props.item.qty | decFormat(6) }}</td>
              <td>{{ props.item.remark }}</td>
              <td>
                {{ props.item.createdDateInMilliSeconds | formatMsDateTime }}
              </td>
              <td>{{ props.item.createdBy }}</td>
              <td>
                {{ props.item.updatedDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--production order reprint format dialog-->
    <production-order-detail-print id="printDetail" :item="selectedItem">
    </production-order-detail-print>
  </v-container>
</template>

<script>
import { ProductionOrder } from "../../models/model";
import { commonService } from "../../services/common-service";
import { productionOrderService } from "../../services/production-order-service";
import { shopService } from "../../services/shop-service";
import { warehouseService } from "../../services/warehouse-service";
import ProductionOrderDetailPrint from "./ProductionOrderDetailPrint";

export default {
  name: "ProductionOrderList",
  components: { ProductionOrderDetailPrint },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    buttonLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Manufacturing Management",
        disabled: true,
      },
      {
        text: "Production Order",
        disabled: true,
      },
    ],
    statusList: [
      { label: "--- ALL ---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
      { label: "CANCEL", value: "CANCEL" },
    ],
    headers: [
      { text: "Action", sortable: false },
      { text: "Status", value: "status" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "PO No", value: "poNo" },
      { text: "Shop", value: "shop.name" },
      { text: "Warehouse", value: "warehouse.name" },
      { text: "From Department", value: "fromDepartment.name" },
      { text: "To Department", value: "toDepartment.name" },
      { text: "Production Plan No", value: "productionPlanNo" },
      { text: "Product Name", value: "product.name" },
      { text: "Unit", value: "unit.name" },
      { text: "Qty", value: "qty" },
      { text: "Remark", value: "remark" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createddBy" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 25,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      poNo: "",
      productionPlanNo: "",
      shopId: "",
      warehouseId: "",
      productName: "",
      productCode: "",
      status: "",
      isAddDetails: true,
      isAddUnits: false,
    },
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    productionOrderList: [],
    shopList: [],
    warehouseList: [],
    selectedItem: new ProductionOrder(),
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductionOrderList();
      },
      deep: true,
    },
  },
  created() {
    this.getAllShopList();
    this.getActiveWarehouseList();
    this.queryParams.shopId = this.checkShopUser();
    this.queryParams.warehouseId = this.checkWarehouseUser();

    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.poNo) {
      this.queryParams.poNo = this.$route.query.poNo;
    }
    if (this.$route.query.productionPlanNo) {
      this.queryParams.productionPlanNo = this.$route.query.productionPlanNo;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = Number(this.$route.query.shopId);
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = Number(this.$route.query.warehouseId);
    }
    if (this.$route.query.productCode) {
      this.queryParams.productCode = this.$route.query.productCode;
    }
    if (this.$route.query.productName) {
      this.queryParams.productName = this.$route.query.productName;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.isAddDetails) {
      this.queryParams.isAddDetails = this.$route.query.isAddDetails;
    }
    if (this.$route.query.isAddUnits) {
      this.queryParams.isAddUnits = this.$route.query.isAddUnits;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    checkWarehouseUser() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "WAREHOUSE_MANAGER" ||
        this.user.role.roleName == "WAREHOUSE_STAFF"
      ) {
        return this.user.warehouseId;
      } else if (this.user.roleName == "PRODUCTION_MANAGER") {
        return this.user.shop.warehouseId;
      } else {
        return "";
      }
    },
    checkShopUser() {
      if (
        this.user.role.roleName == "BRANCH_ADMIN" ||
        this.user.role.roleName == "PRODUCTION_MANAGER"
      ) {
        return this.user.shopId;
      } else {
        return "";
      }
    },
    getAllShopList() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          this.shopList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getActiveWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          this.warehouseList.unshift({ id: "", name: "---ALL---" });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "production-orders",
        query: this.queryParams,
      });
      this.getProductionOrderList();
    },
    getProductionOrderList() {
      this.showListLoading = true;
      this.queryParams.isAddDetails = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productionOrderService
        .getProductionOrderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productionOrderList = res.data.productionOrderList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    exportAllProductionOrder() {
      this.buttonLoading = true;
      this.queryParams.isAddDetails = true;
      productionOrderService
        .exportAllProductionOrderExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.buttonLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/production-order/new");
    },
    onEdit(ProductionOrder) {
      // go to details page
      this.$router.push("/production-order/" + ProductionOrder.id);
    },
    async reprint(item) {
      this.selectedItem = item;
      await this.$nextTick();

      this.reprintPODetail("printDetail");
    },
    reprintPODetail(divName) {
      var printContents = document.getElementById(divName).innerHTML;
      var reprintWindow = window.open("", "MsgWindow", "width=500,height=500");
      reprintWindow.document.writeln(printContents);
      setTimeout(() => {
        reprintWindow.print();
        reprintWindow.close();
      }, 600);
    },
  },
};
</script>
